import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import useForm from 'react-hook-form';

import AlertMsg from '../AlertMsg';
import ErrorMsgField from '../../components/ErrorMsgField';
import schema from '../../form-validation/changePassword';
import api from '../../api';

const ModalChangePassword = props => {
  const { handleModalClose, showModal, user } = props;
  const { register, handleSubmit, errors, reset } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const INITIAL_VALUES = {
    user,
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  };
  const [data, setData] = useState(INITIAL_VALUES);
  const [isFetching, setIsFetching] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorStatusCode, setErrorStatusCode] = useState(0);
  const [showCurrentPwd, setShowCurrentPwd] = useState(false);
  const [showNewPwd, setShowNewPwd] = useState(false);
  const [showConfirmNewPwd, setShowConfirmNewPwd] = useState(false);

  const handleExited = () => {
    setShowCurrentPwd(false);
    setShowNewPwd(false);
    setShowConfirmNewPwd(false);
    setData({ ...INITIAL_VALUES });
  };

  const submit = async () => {
    try {
      setIsFetching(true);
      await api().post('/api/auth/change_password', data);
      setIsSuccess(true);
      reset();
      setData({ ...INITIAL_VALUES });
    } catch (err) {
      console.error(err);
      setIsError(true);
      setErrorStatusCode(err.response ? err.response.status : 0);
    } finally {
      setTimeout(() => {
        setIsFetching(false);
        setIsSuccess(false);
        setIsError(false);
        setErrorStatusCode(0);
      }, 2500);
    }
  };

  const handleChange = evt => {
    evt.preventDefault();
    if (evt.target.getAttribute('number') === 'on') {
      if (evt.target.value.match(/^\d+$/) || evt.target.value === '') {
        setData({
          ...data,
          [evt.target.name]: evt.target.value
        });
      } else {
        evt.target.value = data[evt.target.name];
      }
    } else {
      const isCheckbox = evt.target.type === 'checkbox';
      setData({
        ...data,
        [evt.target.name]: isCheckbox ? evt.target.checked : evt.target.value
      });
    }
  };

  return (
    <React.Fragment>
      <Modal
        show={showModal}
        onHide={handleModalClose}
        onExited={handleExited}
        animation={true}
      >
        <Modal.Body>
          {!isSuccess && !isError && (
            <AlertMsg type="info" msg="Área de troca da senha" />
          )}
          {isSuccess && !isError && isFetching && (
            <AlertMsg type="success" msg="Senha alterada com sucesso" />
          )}
          {isError && errorStatusCode === 403 && isFetching && (
            <AlertMsg type="danger" msg="Senha atual não confere" />
          )}
          {isError && errorStatusCode !== 403 && isFetching && (
            <AlertMsg type="danger" msg="Falha durante troca da senha" />
          )}
          <form onSubmit={handleSubmit(submit)}>
            <input type="hidden" name="username" />
            <div className="form-group form-inline mb-0 mt-2">
              <label
                className="col-sm-12 p-0 d-inline"
                htmlFor="currentPassword"
              >
                Senha Atual
              </label>
              <input
                type={
                  !showCurrentPwd && data.currentPassword.length
                    ? 'password'
                    : 'text'
                }
                className="form-control w-75"
                id="currentPassword"
                name="currentPassword"
                autoComplete="off"
                placeholder="Digite sua senha atual"
                onChange={handleChange}
                ref={register}
              />
              <button
                type="button"
                className="btn btn-dark rounded-0 w-25"
                onClick={() => setShowCurrentPwd(!showCurrentPwd)}
              >
                <i
                  className={`fa ${showCurrentPwd ? 'fa-eye-slash' : 'fa-eye'}`}
                />
              </button>
              <div className="w-100">
                {errors.currentPassword &&
                  errors.currentPassword.type === 'required' && (
                  <ErrorMsgField type="required" />
                )}
                {errors.currentPassword &&
                  errors.currentPassword.type === 'min' && (
                  <ErrorMsgField type="min" />
                )}
                {errors.currentPassword &&
                  errors.currentPassword.type === 'max' && (
                  <ErrorMsgField type="max" />
                )}
                {!errors.currentPassword && (
                  <small className="form-text m-0">&nbsp;</small>
                )}
              </div>
            </div>
            <div className="form-group form-inline mb-0">
              <label className="col-sm-12 p-0 d-inline" htmlFor="newPassword">
                Nova Senha
              </label>
              <input
                type={
                  !showNewPwd && data.newPassword.length ? 'password' : 'text'
                }
                className="form-control w-75"
                id="newPassword"
                name="newPassword"
                autoComplete="off"
                placeholder="Senha com mínimo de 8 caracteres"
                onChange={handleChange}
                ref={register}
              />
              <button
                type="button"
                className="btn btn-dark rounded-0 w-25"
                onClick={() => setShowNewPwd(!showNewPwd)}
              >
                <i className={`fa ${showNewPwd ? 'fa-eye-slash' : 'fa-eye'}`} />
              </button>
              <div className="w-100">
                {errors.newPassword &&
                  errors.newPassword.type === 'required' && (
                  <ErrorMsgField type="required" />
                )}
                {errors.newPassword && errors.newPassword.type === 'min' && (
                  <ErrorMsgField type="min" />
                )}
                {errors.newPassword && errors.newPassword.type === 'max' && (
                  <ErrorMsgField type="max" />
                )}
                {!errors.newPassword && (
                  <small className="form-text m-0">&nbsp;</small>
                )}
              </div>
            </div>
            <div className="form-group form-inline mb-0">
              <label
                className="col-sm-12 p-0 d-inline"
                htmlFor="confirmNewPassword"
              >
                Confirma Nova Senha
              </label>
              <input
                type={
                  !showConfirmNewPwd && data.confirmNewPassword.length
                    ? 'password'
                    : 'text'
                }
                className="form-control w-75"
                id="confirmNewPassword"
                name="confirmNewPassword"
                autoComplete="off"
                placeholder="Confirme sua nova senha"
                onChange={handleChange}
                ref={register}
              />
              <button
                type="button"
                className="btn btn-dark rounded-0 w-25"
                onClick={() => setShowConfirmNewPwd(!showConfirmNewPwd)}
              >
                <i
                  className={`fa ${
                    showConfirmNewPwd ? 'fa-eye-slash' : 'fa-eye'
                  }`}
                />
              </button>
              <div className="w-100">
                {errors.confirmNewPassword &&
                  errors.confirmNewPassword.type === 'required' && (
                  <ErrorMsgField type="required" />
                )}
                {errors.confirmNewPassword &&
                  errors.confirmNewPassword.type === 'min' && (
                  <ErrorMsgField type="min" />
                )}
                {errors.confirmNewPassword &&
                  errors.confirmNewPassword.type === 'max' && (
                  <ErrorMsgField type="max" />
                )}
                {errors.confirmNewPassword &&
                  errors.confirmNewPassword.type === 'confirmNewPassword' && (
                  <ErrorMsgField type="confirmPassword" />
                )}
                {!errors.confirmNewPassword && (
                  <small className="form-text m-0">&nbsp;</small>
                )}
              </div>
            </div>
            <div className="mt-1">
              <Button variant="secondary" onClick={handleModalClose}>
                <i className="fa fa-times"></i>
                &nbsp;Fechar
              </Button>
              <Button
                type="submit"
                className="float-right"
                variant="primary"
                disabled={isFetching}
              >
                <i className="fa fa-save"></i>
                &nbsp;Salvar
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalChangePassword.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool,
  user: PropTypes.string
};

export default ModalChangePassword;
